document.addEventListener("DOMContentLoaded", function () {
  var slides = document.querySelectorAll(".announcement-slide");
  var leftBtn = document.querySelector(".announcement-btn.left");
  var rightBtn = document.querySelector(".announcement-btn.right");
  var current = 0;
  var timer = null;
  var delay = 10000;
  var direction = -1; // -1: 向左（prev），1: 向右（next）
  var carousel = document.querySelector(".announcement-carousel");
  var isHovered = false; // 新增：悬浮状态标记
  
  if (carousel && carousel.dataset.interval) {
    delay = parseInt(carousel.dataset.interval, 10) * 1000 || delay;
  }

  // 只有一条数据时也要显示
  if (slides.length === 1) {
    slides[0].classList.add("active");
    if (carousel) {
      carousel.style.height = slides[0].offsetHeight + "px";
    }
    return;
  }
  if (slides.length === 0) return;

  function updateBtnStatus() {
    if (leftBtn) leftBtn.classList.toggle("disabled", current === 0);
    if (rightBtn)
      rightBtn.classList.toggle("disabled", current === slides.length - 1);
  }

  function updateCarouselHeight() {
    if (!carousel) return;
    var activeSlide = carousel.querySelector(".announcement-slide.active");
    if (activeSlide) {
      carousel.style.height = activeSlide.offsetHeight + "px";
    }
  }

  function showSlide(idx, direction) {
    if (idx === current) return;
    var prev = current;

    // 先移除所有动画类
    slides[prev].classList.remove("ease-fade-in", "ease-fade-out", "active");
    slides[idx].classList.remove("ease-fade-in", "ease-fade-out", "active");

    // 1. 先让当前slide淡出
    slides[prev].classList.add("ease-fade-out");

    // 2. 300ms后开始新slide淡入（更早开始，过渡更平滑）
    setTimeout(function () {
      slides[idx].classList.add("ease-fade-in");
      slides[idx].classList.add("active");
    }, 300);

    // 3. 1000ms后清理
    setTimeout(function () {
      slides[prev].classList.remove("ease-fade-out");
      slides[idx].classList.remove("ease-fade-in");
      updateCarouselHeight();
    }, 1000);

    current = idx;
    updateBtnStatus();
    updateCarouselHeight();
  }

  function nextSlide() {
    if (current < slides.length - 1) {
      showSlide(current + 1, 1);
    }
  }

  function prevSlide() {
    if (current > 0) {
      showSlide(current - 1, -1);
    }
  }

  function autoSlide() {
    if (direction === -1) {
      if (current > 0) {
        prevSlide();
      } else {
        direction = 1;
        nextSlide();
      }
    } else {
      if (current < slides.length - 1) {
        nextSlide();
      } else {
        direction = -1;
        prevSlide();
      }
    }
  }

  function startAuto() {
    if (!isHovered) { // 新增：只有非悬浮状态才启动
      timer = setInterval(autoSlide, delay);
    }
  }

  function stopAuto() {
    clearInterval(timer);
    timer = null;
  }

  function restartAuto() {
    stopAuto();
    setTimeout(startAuto, delay);
  }

  // 新增：鼠标悬浮事件
  if (carousel) {
    carousel.addEventListener("mouseenter", function() {
      isHovered = true;
      stopAuto(); // 悬浮时停止自动切换
    });
    
    carousel.addEventListener("mouseleave", function() {
      isHovered = false;
      startAuto(); // 离开时恢复自动切换
    });
  }

  if (leftBtn && rightBtn) {
    leftBtn.addEventListener("click", function () {
      if (current > 0) {
        prevSlide();
        direction = -1;
        restartAuto();
      }
    });
    rightBtn.addEventListener("click", function () {
      if (current < slides.length - 1) {
        nextSlide();
        direction = 1;
        restartAuto();
      }
    });
  }

  window.addEventListener("resize", updateCarouselHeight);

  showSlide(current);
  updateCarouselHeight();
  startAuto();
});
